
import global from '@/utils/global'
import { defineComponent } from 'vue'
import { getDispatchExamine, cancelDispatchExamine, getCompanyList } from '@/api/long-insure'
import { BillDetailDto, BillDto } from '@/api/bill'
import batchPayroll from '@/components/batch-payroll.vue'
import { insureDispatchList, insureDispatchDelete, addDispatch } from '@/api/insure-deduction'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getDailyHandleStaffListApi } from '@/api/insure-daily-ax'

export default defineComponent({
  name: 'InsureDailyClaim',
  components: {},
  data() {
    return {
      formSearch: {
        searchUserInfo: ''
      },
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableData: [],
      selects: [] as string[] // 列表选中
    }
  },
  created() {
    this.initTableList()
  },
  watch: {},
  methods: {
    async initTableList() {
      const result = await getDailyHandleStaffListApi({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        searchUserInfo: this.formSearch.searchUserInfo
      })
      console.log(this.formSearch, result, '在线选择 获取历史员工列表')
      this.total = result.totalCount
      this.tableData = result.list
    },
    onSearch() {
      this.pageNum = 1
      this.initTableList()
    },
    onReset() {
      this.formSearch = {
        projectTime: ''
      }
      this.onSearch()
    },
    handleSizeChange() {
      this.pageNum = 1
      this.initTableList()
    },

    // 添加
    onAdd() {
      console.log('添加派遣单位')
      this.$emit('emitAddStaff', this.selects)
    },
    // 点击出险人姓名
    onClickName(row) {
      console.log('点击出险人姓名', row.name)
    },
    handleSelectionChange(selects: { id: string }[]) {
      this.selects = selects
    }
  }
})
